/**
 * Whether the user wants clicks to open the inspector.
 *
 * Lives with the feature rather than with the Settings card that toggles it, so
 * a surface asking "should I offer this?" does not have to import from settings.
 *
 * Backed by `DisplayPrefsStore`, which the dashboard scopes to
 * `{ app: "dashboard" }` — remembered per browser, not per user. See
 * {@link InspectorSection} for why that is acceptable for now.
 */
import { useDisplayPref, usePlan } from "@authe/ui-core";
import { displayPrefs } from "@/app/prefs";

export function useInspectorPref(): [boolean, (enabled: boolean) => void] {
  const { plan } = usePlan();
  const [enabled, setEnabled] = useDisplayPref<boolean>(
    () => displayPrefs.getInspector(),
    (enabled) => displayPrefs.setInspector(enabled),
  );
  // A browser may retain a paid user's preference. Free always opens the full
  // record, while preserving that preference for a later upgrade.
  return [plan?.id === "free" ? false : enabled, setEnabled];
}
